import { AxiosError } from 'axios';

import strings from 'constants/index';

function getResponseMessages(data: unknown): string[] | undefined {
  if (
    data &&
    typeof data === 'object' &&
    'messages' in data &&
    Array.isArray((data as { messages: unknown }).messages) &&
    (data as { messages: unknown[] }).messages.every(m => typeof m === 'string')
  ) {
    return (data as { messages: string[] }).messages;
  }
  return undefined;
}

const errorRegexes = [
  {
    regex: new RegExp(
      /^Inserted value: ".*" for property: "Website1" is not a valid property value type: "Link"!$/,
    ),
    message: 'Invalid Website1 value!',
  },
];

const formatMessage = (message: string) => {
  const regex = errorRegexes.find(({ regex }) => regex.test(message));

  return regex?.message || message;
};

const handleErrorMessage = (error: AxiosError): string[] => {
  if (error.response?.status === 403) {
    return [strings.unathorized_error_message];
  }

  return [error.message];
};

export const formatError = (e: AxiosError): string => {
  if (!e) {
    return '';
  }
  let message = '';
  const messages = e.response?.data != null ? getResponseMessages(e.response.data) : undefined;
  if (messages?.length) {
    message = messages.join('\n');
  } else {
    message = e.message;
  }

  return formatMessage(message);
};

export const formatErrorArray = (e: AxiosError): string[] => {
  if (!e) {
    return [];
  }
  let message: string[];
  const messages = e.response?.data != null ? getResponseMessages(e.response.data) : undefined;
  if (messages?.length) {
    message = messages;
  } else {
    message = handleErrorMessage(e);
  }

  const formattedMessages = message.map(formatMessage);

  return formattedMessages;
};
